import { apiAthenas } from '@/services/api/apiAthenas'
import { AiData } from '@/types/AiData'

export async function getAiData(demandId: string) {
  const { data } = await apiAthenas.get<AiData[]>(`demands/${demandId}/iaData`)

  return data
}
